import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditHotelExtra from "../../components/hotelExtras/FormAddEditHotelExtra";
import { useNavigate } from "react-router-dom";

const CreateHotelExtra = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditHotelExtra
                isEdit={false}
                onSubmitSuccess={() => navigate("/hotel-extras")}
            />
        </WrapperSection>
    );
};

export default CreateHotelExtra;
